import React from "react";
import "./Elegirnos.css";
import global from "../assets/GlobeHemisphereWest-icon.png";
import leaf from "../assets/Leaf-icon.png";
import heart from "../assets/Heart.png";
import medal from "../assets/Medal.png";

export const Elegirnos = () => {
    return (
        <section className="porQueElegirnos">
            <h1>¿Por qué elegirnos?</h1>
            <article className="porQueElegirnos__info">
                <img src={global} className="iconos" alt="" />
                <p>
                Sabemos lo importante que es el medioambiente y contribuimos en su
                cuidado utilizando insumos de origen vegetal, de esta manera generamos
                el menor impacto posible y disminuimos la contaminación.
                </p>
            </article>
            <article className="porQueElegirnos__info">
                <img src={leaf} className="iconos" alt="" />
                <p>
                Utilizamos esencias puras de origen vegetal en nuestros productos. A
                partir de sus propiedades y fragancias intensas logramos combinarlos
                con los beneficios de la aromaterapia.
                </p>
            </article>
            <article className="porQueElegirnos__info">
                <img src={heart} className="iconos" alt="" />
                <p>
                Ofrecemos productos que se adaptan a las preferencias del cliente
                creando un producto único que refleja su personalidad y satisface su
                necesidad.
                </p>
            </article>
            <article className="porQueElegirnos__info">
                <img src={medal} className="iconos" alt=""/>
                <p>
                Estamos comprometidos con la calidad de nuestros productos, por esta
                razón nuestro equipo utiliza materias primas de excelente calidad y se
                capacita en conocer las propiedades de cada insumo que se utiliza para
                crear el producto final. De esta manera nuestros clientes tienen más
                conocimientos sobre el producto y que beneficios le otorga a la hora
                de elegirlos.
                </p>
            </article>
        </section>
    );
};
